// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"5947b467","982":"3c59c010"}[chunkId] + ".chunk.css";
};